module.exports = __webpack_public_path__ + "static/media/is.804c997b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/is.svg
// module id = 154
// module chunks = 0